export default "__VITE_ASSET__DMGyNIlm__"